import { formatId } from "./Utils";

// A buyer's NTN / CNIC as the Add Buyer form holds it: upper case, no dashes.
//
//   NTN   7 digits, or a letter and 6 digits, optionally followed by its check
//         digit (shown 0000092-2). FBR's APIs and invoices take the first 7
//         characters, so those are what is checked and saved.
//   CNIC  13 digits (shown 35202-1234567-8).
//
// Mirrors parseTaxId in the backend (src/services/taxId.js).

const NTN_PATTERN = /^([0-9]{7}|[A-Z][0-9]{6})[0-9]?$/;
const CNIC_PATTERN = /^[0-9]{13}$/;

/** How the field shows it: 0000092-2 / 35202-1234567-8. */
export const formatTaxId = (value, idType) => {
  if (idType !== "NTN") return formatId(value, idType);
  const ntn = String(value || "");
  return ntn.length > 7 ? `${ntn.slice(0, 7)}-${ntn.slice(7)}` : ntn;
};

/**
 * The number to check and save - an NTN without its check digit - or ""
 * while what was typed is incomplete or not a valid NTN / CNIC.
 */
export const completeTaxId = (value, idType) => {
  const typed = String(value || "").toUpperCase();
  if (idType === "CNIC") return CNIC_PATTERN.test(typed) ? typed : "";
  const ntn = NTN_PATTERN.exec(typed);
  return ntn ? ntn[1] : "";
};
